import Api from "../../Api";
import Constants from "../../Constants";
import {map} from "rxjs/operators";
import {UserGroupDto} from "./UserGroupDto";
import {UserGroupCreateDto} from "./UserGroupCreateDto";
import {UserGroupUpdateDto} from "./UserGroupUpdateDto";
import {UserGroupMemberDto} from "./UserGroupMemberDto";
import {UserGroupCollectionPermissionDto} from "./UserGroupCollectionPermissionDto";

export class UserGroupApiClient {
    public static readonly ENDPOINT_URL: string = Constants.REST_API_URL + "/user-groups";

    findAll(): Promise<UserGroupDto[]> {
        const request = {
            url: UserGroupApiClient.ENDPOINT_URL,
            method: "GET",
        };
        return Api.createAjax(request)
                .pipe(
                    map((response) => response.response as UserGroupDto[])
                )
                .toPromise();
    }

    findById(groupId: string): Promise<UserGroupDto> {
        const request = {
            url: `${UserGroupApiClient.ENDPOINT_URL}/${groupId}`,
            method: "GET",
        };
        return Api.createAjax(request)
                .pipe(
                    map((response) => response.response as UserGroupDto)
                )
                .toPromise();
    }

    create(create: UserGroupCreateDto): Promise<UserGroupDto> {
        const request = {
            url: UserGroupApiClient.ENDPOINT_URL,
            method: "POST",
            body: create,
        };
        return Api.createAjax(request)
                .pipe(
                    map((response) => response.response as UserGroupDto)
                )
                .toPromise();
    }

    update(groupId: string, update: UserGroupUpdateDto): Promise<void> {
        const request = {
            url: `${UserGroupApiClient.ENDPOINT_URL}/${groupId}`,
            method: "PUT",
            body: update,
        };
        return Api.createAjax(request)
                .pipe(
                    map(() => {})
                )
                .toPromise();
    }

    delete(groupId: string): Promise<void> {
        const request = {
            url: `${UserGroupApiClient.ENDPOINT_URL}/${groupId}`,
            method: "DELETE",
        };
        return Api.createAjax(request)
                .pipe(
                    map(() => {})
                )
                .toPromise();
    }

    findAllMembers(groupId: string): Promise<UserGroupMemberDto[]> {
        const request = {
            url: `${UserGroupApiClient.ENDPOINT_URL}/${groupId}/members`,
            method: "GET",
        };
        return Api.createAjax(request)
                .pipe(
                    map((response) => response.response as UserGroupMemberDto[])
                )
                .toPromise();
    }

    addMember(groupId: string, userLogin: string): Promise<void> {
        const request = {
            url: `${UserGroupApiClient.ENDPOINT_URL}/${groupId}/members/${userLogin}`,
            method: "POST",
        };
        return Api.createAjax(request)
                .pipe(
                    map(() => {})
                )
                .toPromise();
    }

    removeMember(groupId: string, userLogin: string): Promise<void> {
        const request = {
            url: `${UserGroupApiClient.ENDPOINT_URL}/${groupId}/members/${userLogin}`,
            method: "DELETE",
        };
        return Api.createAjax(request)
                .pipe(
                    map(() => {})
                )
                .toPromise();
    }

    findAllPermissions(groupId: string): Promise<UserGroupCollectionPermissionDto[]> {
        const request = {
            url: `${UserGroupApiClient.ENDPOINT_URL}/${groupId}/permissions`,
            method: "GET",
        };
        return Api.createAjax(request)
                .pipe(
                    map((response) => response.response as UserGroupCollectionPermissionDto[])
                )
                .toPromise();
    }

    createPermission(groupId: string, collectionCode: string, permissionLevelCode: string): Promise<void> {
        const request = {
            url: `${UserGroupApiClient.ENDPOINT_URL}/${groupId}/permissions/${collectionCode}`,
            method: "PUT",
            body: {permissionLevelCode},
        };
        return Api.createAjax(request)
                .pipe(
                    map(() => {})
                )
                .toPromise();
    }

    deletePermission(groupId: string, collectionCode: string): Promise<void> {
        const request = {
            url: `${UserGroupApiClient.ENDPOINT_URL}/${groupId}/permissions/${collectionCode}`,
            method: "DELETE",
        };
        return Api.createAjax(request)
                .pipe(
                    map(() => {})
                )
                .toPromise();
    }
}

export default new UserGroupApiClient();
